<template>
  <div>
    <PayOrderDetails
      :isOpen.sync="payOrderDetailsPanel"
      v-bind:selectedPayOrder="selectedPayOrder"
      @updatePayOrders="loadPayOrders()"
      @close="resetPayOrderDetails()" />

    <v-flex xs12>
      <div class="elevation-1 text-center paper mb-1">
        <v-tabs v-model="tab" class="mb-2">
          <v-tabs-slider></v-tabs-slider>

          <v-tab class="tab">
            Ordenes de pago
          </v-tab>
          <v-tab class="tab">
            Ordenes de pago sin soporte - anticipos
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tabs-items">
          <v-tab-item class="transactions-tab">
            <v-data-table
              :loading-text="payOrdersTable.title"
              :loading="payOrdersTable.loading"
              :headers="payOrdersTable.headers"
              :items="payOrdersTable.data"
              :options="payOrdersTable.options"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50]
              }"
              :sort-by="['createdAt', 'supplier']"
              :sort-desc="[true, false]"
              class="elevation-1">
              <template v-slot:top>
                <div class="px-3">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="d-flex align-center">
                        <span class="mr-3">
                          Filtros:
                        </span>
                        <v-menu
                          ref="datePicker"
                          v-model="datePicker"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="range"
                              label="Rango de fechas"
                              prepend-icon="mdi-calendar"
                              readonly
                              outlined
                              rounded
                              hide-details
                              dense
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dates"
                            :range="true"
                            first-day-of-week="1"
                            :allowed-dates="allowedDates"
                            no-title
                          >
                            <div>
                              <div class="d-flex">
                                <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                                <v-spacer/>
                                <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                                <v-btn :disabled="dates.length < 2" color="primary" @click="loadPayOrders()">OK</v-btn>
                              </div>
                            </div>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="statusSelected"
                        :items="statuses"
                        item-text="text"
                        item-value="value"
                        label="Status"
                        hide-details
                        outlined
                        rounded
                        dense
                        @change="loadPayOrders()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Busca proveedor"
                        dense
                        outlined
                        rounded
                      />
                    </v-col>
                  </v-row>
                </div>
              </template>
              <template v-slot:[`item._id`]="{ item }">
                <div>
                  <a @click="openPayOrderDetailsPanel(item)"  class="link">{{ item._id }}</a>
                </div>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <div class="text-right">
                  {{ item.total | toFix2 | numberWithComma | prefix('$') }}
                </div>
              </template>
              <template v-slot:[`item.createdAt`]="{ item }">
                <div>
                  {{ $moment(item.createdAt).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.paymentMethod`]="{ item }">
                <div>
                  {{ PAYORDER_PAYMENT_TYPES[item.paymentMethod] }}
                </div>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <div>
                  {{ PAYORDER_STATUS_TYPES[item.status] }}
                </div>
              </template>
              <template v-slot:[`item.support`]="{ item }">
                <div class="d-flex justify-end align-center">
                  <v-tooltip left v-if="item.file">
                    <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-3"
                          fab
                          color="info"
                          x-small
                          depressed
                          tag="a"
                          target="_blank"
                          :href="openDocumentViewer(item)">
                          <v-icon color="white">
                            mdi-file-pdf-box
                          </v-icon>
                        </v-btn>
                    </template>
                    <span>Ver pdf</span>
                  </v-tooltip>
                  <v-tooltip left v-if="item.invoice">
                    <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-3"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openInvoiceViewer(item.invoice)">
                          <v-icon>
                            mdi-receipt
                          </v-icon>
                        </v-btn>
                    </template>
                    <span>Ver factura</span>
                  </v-tooltip>
                  <v-tooltip left v-if="movementsPermissions['delete-pay-order']">
                    <template
                      v-slot:activator="{ on }">
                      <v-btn
                        fab
                        x-small
                        depressed
                        class="mr-3"
                        color="error"
                        v-on="on"
                        @click="openRemoveDialog(item)"
                        >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Borrar orden de pago</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item class="relations-tab">
            <PayOrdersWithoutSupport />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-flex>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas borrar la orden de pago?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="black darken-1" text @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <InvoiceViewer ref="invoiceViewer" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEmpty, debounce } from 'lodash'

// import AddPayOrder from '@/components/sidePanels/AddPayOrder'
import PayOrderDetails from '@/components/sidePanels/PayOrderDetails'
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import PayOrdersWithoutSupport from '@/screens/expenses/PayOrdersWithoutSupport'

export default {
  name: 'PaymentOrders',
  components: {
    // AddPayOrder,
    PayOrderDetails,
    InvoiceViewer,
    PayOrdersWithoutSupport
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.registerMovements.section'),
      payOrdersTable: {
        title: this.$i18n.t('expenses.registerMovements.payOrders.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.supplier'), value: 'providerName', sortable: true },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.amount'), value: 'total' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.date'), value: 'createdAt' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.paymentType'), value: 'paymentMethod', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.status'), value: 'status' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.support'), value: 'support' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 30,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        },
        selected: []
      },
      search: '',
      statusSelected: '',
      datePicker: false,
      dates: [],
      isAddPayOrderPanelOpen: false,
      loadingBtn: '',
      disabled: false,
      payOrderDetailsPanel: false,
      selectedPayOrder: null,
      PAYORDER_PAYMENT_TYPES: {
        balance: this.$i18n.t('expenses.registerMovements.movements.paymentTypes.balance'),
        credit: this.$i18n.t('expenses.registerMovements.movements.paymentTypes.credit')
      },
      PAYORDER_STATUS_TYPES: {
        created: this.$i18n.t('expenses.registerMovements.movements.statusTypes.created'),
        pending_payment: this.$i18n.t('expenses.registerMovements.movements.statusTypes.pendingPayment'),
        paid: this.$i18n.t('expenses.registerMovements.movements.statusTypes.paid')
      },
      suppliers: {
        data: [],
        loading: false
      },
      removeDialog: false,
      removePayOrder: {},
      tab: null
    }
  },
  async mounted () {
    await this.loadPayOrders()
  },
  computed: {
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    },
    statuses () {
      return [
        { text: 'Por pagar', value: 'pending_payment' },
        { text: 'Pagada', value: 'paid' }
      ]
    },
    range () {
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    }
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 2) {
        const params = {
          restaurant: this.$store.state.currentRestaurant.data._id,
          providerName: `/${val}/i`,
          skip: 0
        }
        if (this.statusSelected) params.status = this.statusSelected
        if (this.dates.length === 2) {
          const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
            if (a > b) return 1
            if (a < b) return -1
            return 0
          })
          params.startDate = (dates[0])
          params.endDate = dates[1]
        }
        this.payOrdersTable.loading = true
        try {
          const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
          this.payOrdersTable.data = response
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.payOrdersTable.loading = false
      } else {
        this.loadPayOrders()
      }
    }, 300),
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
      await this.loadPayOrders()
    },
    tab: function () {
      if (this.tab === 0) {
        this.loadPayOrders()
      }
    }
  },
  methods: {
    openDocumentViewer (order) {
      let url = `${process.env.VUE_APP_API_URL}/v1/expenses/${this.$store.state.currentRestaurant.data._id}/detail-document/${order._id}`
      url += `?access_token=${this.$store.state.login.token}`
      return url
    },
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    resetForm () {
      this.payOrdersTable.data = []
      this.payOrdersTable.total = 0
      this.payOrdersTable.selected = []
      this.isAddPayOrderPanelOpen = false
      this.loadingBtn = ''
      this.disabled = false
      this.payOrderDetailsPanel = false
      this.selectedPayOrder = null
    },
    async getXml (id) {
      let xml = null
      this.disabled = true
      this.loadingBtn = id
      try {
        const { invoice } = await this.$api.get(`/v1/invoices/${id}/cfdi`)
        xml = invoice
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.disabled = false
      this.loadingBtn = ''
      return xml
    },
    async loadPayOrders (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      if (this.statusSelected) params.status = this.statusSelected
      if (this.dates.length === 2) {
        const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
          if (a > b) return 1
          if (a < b) return -1
          return 0
        })
        params.startDate = (dates[0])
        params.endDate = dates[1]
        this.datePicker = false
      }
      this.payOrdersTable.loading = true
      try {
        const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
        this.payOrdersTable.selected = []
        this.payOrdersTable.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.payOrdersTable.loading = false
    },
    openAddPayOrderPanel () {
      this.isAddPayOrderPanelOpen = true
    },
    openPayOrderDetailsPanel (item) {
      this.selectedPayOrder = item
      this.payOrderDetailsPanel = true
    },
    closePayOrderDetailsPanel () {
      this.payOrderDetailsPanel = false
    },
    resetPayOrderDetails () {
      this.selectedPayOrder = {}
    },
    async openInvoiceViewer (item) {
      if (item) {
        await this.$refs.invoiceViewer.open(item)
      } else {
        const invoice = {}
        invoice.xml = await this.getXml(item.id)
        await this.$refs.invoiceViewer.open(invoice)
      }
    },
    isEmpty,
    loadSuppliers: async function () {
      const params = {
        // fetchAll: true,
        // select: 'name'
      }
      this.suppliers.loading = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/providers`, params)
        this.suppliers.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.suppliers.loading = false
    },
    findSupplierName (supplierId) {
      const supplier = this.suppliers.data.find(supplier => supplier._id === supplierId)
      return isEmpty(supplier) ? undefined : supplier.name
    },
    async resetDate () {
      this.dates = []
      await this.loadPayOrders()
      this.datePicker = false
    },
    async openRemoveDialog (item) {
      this.removeDialog = true
      this.removePayOrder = item
    },
    onCloseRemoveDialog () {
      this.removeDialog = false
      this.removePayOrder = {}
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/invoices/${this.removePayOrder.invoice.uuid}`)
        await this.$api.del(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/${this.removePayOrder._id}`)
        this.$toasted.show('Orden de pago eliminada exitosamente', { duration: 3000 })
        await this.loadPayOrders()
        this.removePayOrder = {}
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.onCloseRemoveDialog()
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }

  .tab {
    font-size: 12px;
  }
</style>
